export default __webpack_public_path__ + "static/media/logo_bar.7d01bb46.png";